import { useState } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartSimple } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Line from "../components/chart/Line";
import Bar from "../components/chart/Bar";
import Line1 from "../components/chart/Line1";
import Line2 from "../components/chart/Line2";
import Line3 from "../components/chart/Line3";
import Line4 from "../components/chart/Line4";
import Pie from "../components/chart/Pie";
import Gauge from "../components/chart/Gauge";

function Chart() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Charts" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Charts" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-4">
                <div className="mycard mt-2">
                    <Bar/>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mycard mt-2">
                    <Line1/>
                </div>
               </div>
               <div className="col-lg-6">
                <div className="mycard mt-2">
                    <Line2/>
                </div>
               </div>
               <div className="col-lg-6">
                <div className="mycard mt-2">
                    <Line4/>
                </div>
               </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Chart